import React, { useState } from "react";
import { toast } from "sonner";
import { X, ClipboardList, Loader2 } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function CreateAssignmentModal({ courses, onClose, onCreated }) {
  const [courseId, setCourseId] = useState(courses[0]?.id || "");
  const [title, setTitle] = useState("");
  const [instructions, setInstructions] = useState("");
  const [busy, setBusy] = useState(false);

  const create = async () => {
    if (!title.trim() || !instructions.trim()) { toast.error("Add a title and instructions"); return; }
    setBusy(true);
    try {
      await api.post(`/courses/${courseId}/assignments`, { title, instructions });
      toast.success("Assignment created!");
      onCreated();
      onClose();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Failed to create assignment");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center px-4" data-testid="create-assignment-modal">
      <div className="glass-panel rounded-2xl p-6 max-w-md w-full">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-heading font-semibold text-white text-sm flex items-center gap-2"><ClipboardList className="w-4 h-4 text-violet-300" /> Create Assignment</h3>
          <button onClick={onClose} data-testid="create-assignment-close-btn" className="text-slate-400 hover:text-white"><X className="w-4 h-4" /></button>
        </div>
        <label className="text-[11px] font-bold uppercase tracking-wider text-slate-400">Course</label>
        <select value={courseId} onChange={(e) => setCourseId(e.target.value)} data-testid="create-assignment-course-select" className="w-full mt-1.5 bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm text-white">
          {courses.map((c) => <option key={c.id} value={c.id}>{c.title}</option>)}
        </select>
        <label className="text-[11px] font-bold uppercase tracking-wider text-slate-400 mt-3 block">Title</label>
        <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="e.g. Build a Data Stream" data-testid="create-assignment-title-input" className="w-full mt-1.5 bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm text-white placeholder:text-slate-500" />
        <label className="text-[11px] font-bold uppercase tracking-wider text-slate-400 mt-3 block">Instructions</label>
        <textarea value={instructions} onChange={(e) => setInstructions(e.target.value)} rows={5} placeholder="Describe what students need to submit..." data-testid="create-assignment-instructions-input" className="w-full mt-1.5 bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm text-white placeholder:text-slate-500 resize-none" />
        <button onClick={create} disabled={busy} data-testid="create-assignment-save-btn" className="w-full mt-4 flex items-center justify-center gap-2 bg-primary hover:bg-primary/90 disabled:opacity-60 text-white text-sm font-semibold py-2.5 rounded-lg">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Create Assignment"}
        </button>
      </div>
    </div>
  );
}
